<app-pop-up
	[id]="popUpId"
	[options]="{}"
>
	<div class="popup popup-biometrics-registration-verification-info">
		<app-loader
			#loaderStep1
			[context]="'element'"
			[isActive]="false"
		></app-loader>
		<button
			class="button-reset close"
			type="button"
			(click)="close()"
		></button>

		<div class="popup__content popup-biometrics-registration-verification-info__content">
			@if (secret) {
				@if (!isOpenConditions) {
					<section>
						<h3 class="popup__header">Подтверждение данных</h3>
						<div
							class="popup__body popup-biometrics-registration-verification-info__body"
						>
							<section
								class="popup-biometrics-registration-verification-info__body-content"
							>
								<div
									class="popup-biometrics-registration-verification-info__message-wrapper"
								>
									<message
										[isAdaptive]="true"
										[titleSuccess]="'Вы прошли удаленную идентификацию'"
										[mode]="MEssageMode.SUCCESS"
									>
										<div resultText>
											<p>
												Проверьте ваши данные ниже и укажите недостающие
												сведения.
											</p>
											<p>
												Если данные неактуальны, вам необходимо изменить их
												на сайте Госуслуг.
											</p>
										</div>
									</message>
								</div>
								<div
									class="popup-biometrics-registration-verification-info__layout-wrapper"
								>
									@if (layout) {
										<app-layout-renderer
											[layout]="layout"
										></app-layout-renderer>
									}
								</div>
							</section>
							<app-error-presenter [errors]="errors"></app-error-presenter>
						</div>
						<div
							class="popup__footer popup-biometrics-registration-verification-info__footer"
						>
							<button
								class="conditions-button"
								type="button"
								(click)="openCondirions()"
							>
								Условия заключаемых договоров
							</button>
							<div
								class="popup-biometrics-registration-verification-info__footer-buttons-right"
							>
								<button
									class="button button--white"
									type="button"
									(click)="close()"
								>
									Не принимаю
								</button>
								<button
									class="button"
									type="button"
									[disabled]="toggleControl.invalid"
									(click)="next()"
								>
									Подтвердить и продолжить
								</button>
							</div>
						</div>
					</section>
				}
				@if (isOpenConditions) {
					<app-individual-conditions-list
						[conditions]="conditions$ | async"
						(titleClick)="conditionsClickOnTitle()"
					></app-individual-conditions-list>
				}
			} @else {
				<h3 class="popup__header">Подтверждение данных</h3>
				<div class="popup__body">
					<message
						[isAdaptive]="true"
						[titleFail]="'Внимание!'"
						[mode]="'fail'"
					>
						<div resultText>При подтверждении данных возникла ошибка.</div>
					</message>
				</div>
				<div class="popup__footer popup-biometrics-registration-error__footer">
					<button
						class="button button--white"
						type="button"
						(click)="close()"
					>
						Отменить
					</button>
				</div>
			}
		</div>
	</div>
</app-pop-up>
